var map;
var mapMarkers = [];

window.initMap = function () {
  const styledMapType = new google.maps.StyledMapType(
    [ /* your long style array here */ ],
    { name: 'Styled Map' }
  );

  let zoom_level = 5;
  if (window.innerWidth < 1000) {
    zoom_level = 4;
  }

  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 36.97554531701727, lng: -95.91219187376399 },
    zoom: zoom_level,
    streetViewControl: false,
    mapTypeControl: false
  });

  map.mapTypes.set('styled_map', styledMapType);
  map.setMapTypeId('styled_map');

  if (window.storeLocations && window.storeLocations.length > 0) {
    setMarkers(map, window.storeLocations);
  }
};

function setMarkers(map, locations) {
  const infoWindows = [];

  locations.forEach(([info, lat, lng, iconUrl]) => {
    const latlng = new google.maps.LatLng(lat, lng);
    const marker = new google.maps.Marker({
      position: latlng,
      map: map,
      icon: {
        url: iconUrl,
        scaledSize: new google.maps.Size(32, 40)
      }
    });

    mapMarkers.push(marker);

    const infoWindow = new google.maps.InfoWindow();
    infoWindows.push(infoWindow);

    marker.addListener("click", function () {
      infoWindows.forEach(iw => iw.close());
      infoWindow.setContent(info);
      infoWindow.open(map, marker);
    });
  });
}